// Top-level error boundary. A page chunk that fails to load (a deploy while the visitor
// had the site open, see utils/chunkReload.js) would otherwise make React unmount the
// whole app: a blank page. Reload once instead; if that already happened a moment ago,
// or for any other error, show a short message with a reload link rather than a blank
// page or a reload loop.
// Renders its children untouched otherwise, so hydration is unaffected.
import React from "react";
import { reloadOnce } from "../utils/chunkReload";

export default class ChunkReloadBoundary extends React.Component {
  state = { error: null, reloading: false };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (reloadOnce(error)) this.setState({ reloading: true });
  }

  render() {
    const { error, reloading } = this.state;
    if (!error) return this.props.children;
    if (reloading) return null;
    const fr = window.location.pathname.startsWith("/fr");
    return (
      <div role="alert" style={{ minHeight: "60vh", display: "grid", placeItems: "center", padding: "2rem 1rem", textAlign: "center" }}>
        <p>
          {fr ? "Cette page n'a pas pu se charger. " : "This page couldn't load. "}
          <a href={window.location.href} style={{ textDecoration: "underline" }}>{fr ? "Recharger la page" : "Reload the page"}</a>
        </p>
      </div>
    );
  }
}
